import React, { useState } from 'react';

function Calculator() {
  const [amount, setAmount] = useState('');
  const [rate, setRate] = useState('');
  const [term, setTerm] = useState('');
  const [result, setResult] = useState(null);

  const calculate = () => {
    const principal = parseFloat(amount);
    const monthlyRate = parseFloat(rate) / 100 / 12;
    const months = parseInt(term) * 12;

    if (!principal || !monthlyRate || !months) return;

    const payment = (principal * monthlyRate) / (1 - Math.pow(1 + monthlyRate, -months));
    setResult(payment.toFixed(2));
  };

  return (
    <div className="card">
      <h3>Loan Calculator</h3>
      <input type="number" placeholder="Amount" value={amount} onChange={e => setAmount(e.target.value)} />
      <input type="number" placeholder="Interest Rate (%)" value={rate} onChange={e => setRate(e.target.value)} />
      <input type="number" placeholder="Term (years)" value={term} onChange={e => setTerm(e.target.value)} />
      <button onClick={calculate}>Calculate</button>
      {result && <p>Monthly Payment: ${result}</p>}
    </div>
  );
}

export default Calculator;
